import React, { useState } from 'react'
import { IoLanguage } from 'react-icons/io5'
import TabAdd from '../pages/page-components/languages/TabAdd';
import TabView from '../pages/page-components/languages/TabView';
import MasterPageTab from '../pages/page-essential/MasterPageTab';
import SideNav from '../pages/page-essential/SideNav'


const Languages = () => {
    const [activeTab, setActiveTab] = useState('view');
    let TabLayout;

    if (activeTab === 'view') TabLayout = <TabView />
    if (activeTab === 'add') TabLayout = <TabAdd />

    return (
        <MasterPageTab addBtn='Add Langugage' addTab={<TabAdd />} viewBtn='All Languages' viewTab={<TabView />} pageHeading='Language' pageDescription='Add/view/modify languages for your site' icon={<IoLanguage />} />
    )
}

export default React.memo(Languages)